export default __webpack_public_path__ + "static/media/team37.6b4974ce.JPG";